/**
 * 다국어(i18n) 훅
 *
 * Redux 스토어의 언어 설정을 기반으로 텍스트 객체를 반환한다.
 * TEXTS 객체는 { ko: {...}, en: {...} } 형태로 전달하며,
 * 현재 언어에 해당하는 텍스트 셋을 t로 반환한다.
 */
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLanguage as setLanguageAction } from '../store/authSlice';

/**
 * 다국어 훅
 * @param {Object} TEXTS - { ko: { key: value, ... }, en: { key: value, ... } }
 * @returns {{ t: Object, language: string, setLanguage: Function }}
 */
const useLanguage = (TEXTS = { ko: {}, en: {} }) => {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.auth.language);

  /** 현재 언어에 해당하는 텍스트 객체 */
  const t = TEXTS[language] || TEXTS.ko;

  /**
   * 언어 변경
   * @param {string} lang - 변경할 언어 코드 ('ko' | 'en')
   */
  const setLanguage = useCallback(
    (lang) => {
      dispatch(setLanguageAction(lang));
    },
    [dispatch]
  );

  return {
    t,
    language,
    setLanguage,
  };
};

export default useLanguage;
